module.exports = __webpack_public_path__ + "static/media/prima-bergamo.eca8592d.png";